var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.9614C21 12.9614 18.5 6.46143 12 6.46143C5.5 6.46143 3 12.9614 3 12.9614",
    stroke: "#516376",
    strokeOpacity: 0.7,
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 17.4616C14.2092 17.4616 16.0001 15.6707 16.0001 13.4615C16.0001 11.2523 14.2092 9.46143 12.0001 9.46143C9.79089 9.46143 8 11.2523 8 13.4615C8 15.6707 9.79089 17.4616 12.0001 17.4616ZM12.2758 16.2895C12.6656 16.2514 12.8579 15.8351 12.7247 15.4668C12.5916 15.0984 12.1724 14.9274 11.7852 14.8683L11.764 14.8649C11.5225 14.8242 11.2956 14.722 11.1052 14.568C10.9148 14.414 10.7673 14.2135 10.6771 13.9859L10.6694 13.9658C10.5305 13.5996 10.2756 13.2254 9.88754 13.1723C9.49951 13.1192 9.13261 13.3943 9.17698 13.7834C9.20521 14.031 9.26602 14.2748 9.3586 14.5084C9.53876 14.963 9.83317 15.3634 10.2134 15.6708C10.5935 15.9783 11.0466 16.1824 11.5288 16.2635C11.7766 16.3052 12.0278 16.3136 12.2758 16.2895Z",
    fill: "#516376",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c436129ad60c640d1d595e5cbf50ccea.svg";
export { ForwardRef as ReactComponent };